export default {"src":"/_next/static/media/homework.cb9b8335.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};